'use client';
import { createLogger } from '@svenskaspelab/nova-core/log';
import { type ReactNode } from 'react';

type ErrorProps = {
  // digest: An automatically generated hash of the error thrown in a Server Component.
  // It can be used to match the corresponding error in server-side logs.
  error: Error & { digest?: string };
  reset: () => void;
  statusCode?: number;
};

export default function Error({ statusCode, error }: ErrorProps): ReactNode {
  createLogger('Error Page').error('Error', error.message);

  // DISCLAIMER:
  // This component should be replaced with a common domain page component, usually placed under nova/<domain>/pages
  // Read more about error handling in the documentation:
  // Nova: https://nova.internt.svenskaspel.se/docs/references/error-handling/
  // Nextjs app router: https://nextjs.org/docs/app/building-your-application/routing/error-handling
  return `${statusCode ?? 500}: ${error.message}`;
}
